<template>
  <v-container grid-list-xs>
    <v-layout row wrap>
      <v-card elevation="0" class="pt-0">
        <v-card-text fill-height class="pt-0">
          <v-container fluid grid-list-lg class="pa-0">
            <v-layout row wrap align-start>
              <v-flex xs6 sm3>
                <v-layout row align-center fill-height>
                  <v-flex pa-0 pl-2 shrink>
                    <v-chip disabled class="pa-0 ma-0 font-weight-bold primary white--text">1</v-chip>
                  </v-flex>
                  <v-flex pa-0 pl-1 mt-2 mb-2>
                    <span class="font-weight-bold primary--text">Remaining Balance</span>
                  </v-flex>
                </v-layout>
                <v-text-field
                  label="Remaining Balance"
                  type="tel"
                  v-model="fields.remaining_balance"
                  ref="recurringTotalAmount"
                  append-icon="fa-dollar"
                  @input="handleChange('balance')"
                  maxlength="9"
                  box
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm3>
                <v-layout row align-center fill-height>
                  <v-flex pa-0 pl-2 shrink>
                    <v-chip disabled class="pa-0 ma-0 font-weight-bold primary white--text">2</v-chip>
                  </v-flex>
                  <v-flex>
                    <span class="font-weight-bold primary--text">Frequency</span>
                  </v-flex>
                </v-layout>
                <v-select
                  label="Frequency"
                  v-model="fields.frequency"
                  :items="recurringTypes"
                  :rules="recurringFrequencyRules"
                  append-icon="fa-refresh"
                  @input="handleChange('frequency')"
                  box
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs6 sm3>
                <v-layout row align-center fill-height>
                  <v-flex pa-0 pl-2 shrink>
                    <v-chip disabled class="pa-0 ma-0 font-weight-bold primary white--text">3</v-chip>
                  </v-flex>
                  <v-flex>
                    <span class="font-weight-bold primary--text"># Payments</span>
                  </v-flex>
                </v-layout>
                <v-text-field
                  label="# Payments"
                  type="number"
                  v-model="fields.payments"
                  :disabled="!fields.start_date || !fields.frequency"
                  append-icon="fa-hashtag"
                  @input="handleChange('payments')"
                  box
                  hide-details
                  :readonly="fields.ongoing"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm3>
                <v-layout row align-center fill-height>
                  <v-flex pa-0 pl-2 shrink>
                    <v-chip disabled class="pa-0 ma-0 font-weight-bold primary white--text">4</v-chip>
                  </v-flex>
                  <v-flex>
                    <span class="font-weight-bold primary--text">Installments</span>
                  </v-flex>
                </v-layout>
                <v-text-field
                  label="Installments"
                  type="tel"
                  v-model="fields.amount"
                  append-icon="fa-dollar"
                  @input="handleChange('amount')"
                  box
                  hide-details
                ></v-text-field>
                <v-layout row class="ma-0 mt-1" style="border: 1px solid #44a9e2;cursor: pointer;" @click="showRecurringPriceAdjustmentFee=true" v-if="!fields.waive_fee && terminal.is_cashdiscount && transaction.request_type !== 'ach' && !showRecurringPriceAdjustmentFee">
                  <v-flex class="pa-1 pt-2 pl-2 caption white primary--text text-truncate">
                    Show Price Adj Fee
                  </v-flex>
                  <v-flex shrink class="pa-0 white">
                    <v-divider vertical class="primary"></v-divider>
                  </v-flex>
                  <v-flex shrink class="pa-1 pl-2 pr-2 caption white primary--text">
                    &or;
                  </v-flex>
                </v-layout>
                <v-layout row class="ma-0 mt-1" style="border: 1px solid #44a9e2;cursor: pointer;" @click="showRecurringPriceAdjustmentFee=false" v-if="!fields.waive_fee && terminal.is_cashdiscount && transaction.request_type !== 'ach' && showRecurringPriceAdjustmentFee">
                  <v-flex class="pa-1 pl-2 caption primary white--text">
                    {{ recurringPriceAdjustmentFee }}
                  </v-flex>
                  <v-flex shrink class="pa-0 primary">
                    <v-divider vertical class="white"></v-divider>
                  </v-flex>
                  <v-flex shrink class="pa-1 pl-2 pr-2 caption primary white--text">
                    &and;
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm3 class="hidden-xs-only">
              </v-flex>
              <v-flex xs6 sm3>
                <v-layout row align-center fill-height>
                  <v-flex pa-0 pl-2 shrink>
                    <v-chip disabled class="pa-0 ma-0 font-weight-bold primary white--text">5</v-chip>
                  </v-flex>
                  <v-flex>
                    <span class="font-weight-bold primary--text">Start Date</span>
                  </v-flex>
                </v-layout>
                <v-menu
                  v-model="startDateModal"
                  ref="startDateModal"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="fields.start_date"
                  full-width
                  lazy
                  min-width="290px"
                  offset-y
                  transition="scale-transition"
                >
                  <v-text-field
                    label="Start Date"
                    slot="activator"
                    v-model="formattedRecurringStartDate"
                    :rules="recurringStartRules"
                    append-icon="fa-calendar"
                    box
                    hide-details
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="fields.start_date"
                    :min="minimumRecurringStartDate"
                    @input="$refs.startDateModal.save(fields.start_date); handleChange('start_date')"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs sm3>
                <v-layout row align-center fill-height>
                  <v-flex pa-0 pl-2 mt-2 mb-2>
                    <span class="font-weight-bold secondary--text">End Date</span>
                  </v-flex>
                </v-layout>
                <v-text-field
                  label="End Date"
                  v-model="formattedRecurringEndDate"
                  append-icon="fa-calendar"
                  box
                  hide-details
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm3 v-if="fields.last_amount">
                <v-layout row align-center fill-height>
                  <v-flex pa-0 pl-2 mt-2 mb-2>
                    <span class="font-weight-bold secondary--text">Last Payment</span>
                  </v-flex>
                </v-layout>
                <v-text-field
                  label="Last Payment"
                  type="tel"
                  v-model="fields.last_amount"
                  append-icon="fa-dollar"
                  box
                  hide-details
                  readonly
                ></v-text-field>
                <v-layout row class="ma-0 mt-1" style="border: 1px solid #44a9e2;cursor: pointer;" @click="showRecurringLastAmountPriceAdjustmentFee=true" v-if="!fields.waive_fee && terminal.is_cashdiscount && transaction.request_type !== 'ach' && !showRecurringLastAmountPriceAdjustmentFee">
                  <v-flex class="pa-1 pt-2 pl-2 caption white primary--text text-truncate">
                    Show Price Adj Fee
                  </v-flex>
                  <v-flex shrink class="pa-0 white">
                    <v-divider vertical class="primary"></v-divider>
                  </v-flex>
                  <v-flex shrink class="pa-1 pl-2 pr-2 caption white primary--text">
                    &or;
                  </v-flex>
                </v-layout>
                <v-layout row class="ma-0 mt-1" style="border: 1px solid #44a9e2;cursor: pointer;"  @click="showRecurringLastAmountPriceAdjustmentFee=false" v-if="!fields.waive_fee && terminal.is_cashdiscount && transaction.request_type !== 'ach' && showRecurringLastAmountPriceAdjustmentFee">
                  <v-flex grow class="pa-1 pl-2 caption primary white--text">
                    {{ recurringLastAmountPriceAdjustmentFee }}
                  </v-flex>
                  <v-flex shrink class="pa-0 primary">
                    <v-divider vertical class="white"></v-divider>
                  </v-flex>
                  <v-flex shrink class="pa-1 pl-2 pr-2 caption primary white--text">
                    &and;
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-layout column wrap>
              <v-flex>
                <div class="font-weight-bold primary--text subheading">IMPORTANT</div>
              </v-flex>
              <v-flex pt-0>
                <div class="caption">All changes to the input boxes above can also be seen below in the Quick-look Summary.</div>
              </v-flex>
            </v-layout>

            <v-divider class="primary"></v-divider>

            <v-layout column wrap>
              <v-flex>
                <span class="primary--text subheading">Quick-look Summary</span>
              </v-flex>
              <v-flex pt-0>
                <table id="modify" width="100%">
                  <tr>
                    <th></th>
                    <th class="primary--text caption">
                      Remainder
                    </th>
                    <th class="primary--text caption">
                      Frequency
                    </th>
                    <th class="primary--text caption">
                      Start Date
                    </th>
                    <th class="primary--text caption">
                      Finish Date
                    </th>
                    <th class="primary--text caption">
                      # Payments
                    </th>
                    <th class="primary--text caption">
                      Installment
                    </th>
                    <th class="primary--text caption">
                      Final
                    </th>
                  </tr>
                  <tr>
                    <td class="subheading">
                      Before
                    </td>
                    <td class="text-xs-center">
                      {{ fields.remaining_balance_original }}
                    </td>
                    <td class="text-xs-center">
                      {{ fields.frequency_original }}
                    </td>
                    <td class="text-xs-center">
                      {{ date(fields.start_date_original) }}
                    </td>
                    <td class="text-xs-center">
                      {{ date(fields.end_date_original) }}
                    </td>
                    <td class="text-xs-center">
                      {{ fields.payments_original }}
                    </td>
                    <td class="text-xs-center">
                      {{ fields.amount_original }}
                    </td>
                    <td class="text-xs-center">
                      {{ fields.last_amount_original }}
                    </td>
                  </tr>
                  <tr><td colspan="8"><v-divider class="primary"></v-divider></td></tr>
                  <tr>
                    <th></th>
                    <th class="primary--text caption">
                      Total
                    </th>
                    <th class="primary--text caption">
                      Frequency
                    </th>
                    <th class="primary--text caption">
                      Start Date
                    </th>
                    <th class="primary--text caption">
                      Finish Date
                    </th>
                    <th class="primary--text caption">
                      # Payments
                    </th>
                    <th class="primary--text caption">
                      Installment
                    </th>
                    <th class="primary--text caption">
                      Final
                    </th>
                  </tr>
                  <tr>
                    <td class="subheading">
                      After
                    </td>
                    <td class="secondary text-xs-center" v-if="Number(fields.remaining_balance) !== Number(fields.remaining_balance_original)">
                      {{ fields.remaining_balance }}
                    </td>
                    <td class="text-xs-center" v-else>
                      {{ fields.remaining_balance }}
                    </td>
                    <td class="secondary text-xs-center" v-if="fields.frequency !== fields.frequency_original">
                      {{ fields.frequency }}
                    </td>
                    <td class="text-xs-center" v-else>
                      {{ fields.frequency }}
                    </td>
                    <td class="secondary text-xs-center" v-if="fields.start_date !== fields.start_date_original">
                      {{ date(fields.start_date) }}
                    </td>
                    <td class="text-xs-center" v-else>
                      {{ date(fields.start_date) }}
                    </td>
                    <td class="secondary text-xs-center" v-if="fields.end_date !== fields.end_date_original">
                      {{ date(fields.end_date) }}
                    </td>
                    <td class="text-xs-center" v-else>
                      {{ date(fields.end_date) }}
                    </td>
                    <td class="secondary text-xs-center" v-if="Number(fields.payments) !== Number(fields.payments_original)">
                      {{ fields.payments }}
                    </td>
                    <td class="text-xs-center" v-else>
                      {{ fields.payments }}
                    </td>
                    <td class="secondary text-xs-center" v-if="Number(fields.amount) !== Number(fields.amount_original)">
                      {{ fields.amount }}
                    </td>
                    <td class="text-xs-center" v-else>
                      {{ fields.amount }}
                    </td>
                    <td class="secondary text-xs-center" v-if="Number(fields.last_amount) !== Number(fields.last_amount_original)">
                      {{ fields.last_amount }}
                    </td>
                    <td class="text-xs-center" v-else>
                      {{ fields.last_amount }}
                    </td>
                  </tr>
                </table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-container fluid grid-list-lg class="pa-0">
            <v-layout row wrap>
              <v-flex xs6 class="text-xs-right">
                <template v-if="submitDisabled">
                  By clicking <span class="primary--text">CONFIRM</span> this installment schedule will be modified with <span class="primary--text">new</span> details.
                </template>
              </v-flex>
              <v-flex xs3>
                <v-btn block large @click="closeModal">Cancel</v-btn>
              </v-flex>
              <v-flex xs3>
                <v-btn block large @click="save" color="primary" :disabled="!submitDisabled">Confirm</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import Moment from 'moment'

import Bus from '@/bus'
import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import CashDiscountMixin from '@/mixins/cashDiscount'
import DisplayMixin from '@/mixins/display'
import RecurringMixin from '@/mixins/recurring'
import StoreMixin from '@/store/mixin'
import UtilityMixin from '@/mixins/utility'

export default {
  mixins: [ApiMixin, AuthMixin, CashDiscountMixin, DisplayMixin, RecurringMixin, StoreMixin, UtilityMixin],

  data: function () {
    return {
      enabled: false,

      showPriceAdjustmentFee: false,
      showRecurringPriceAdjustmentFee: false,
      showRecurringLastAmountPriceAdjustmentFee: false,

      startDateModal: false,
      endDateModal: false,

      current_date: Moment().format('YYYY-MM-DD'),

      fields: {
        token: null,
        // amount: null,
        downpayment: 0.00,
        fee: '0.00',
        fee_waived: '0.00',
        waive_fee: false,
        fee_per_installment: '0.00',
        close_date: null,

        remaining_balance: null,
        remaining_balance_original: null,

        frequency: 'none',
        frequency_original: 'none',

        payments: 0,
        payments_original: 0,

        amount: null,
        amount_original: null,

        start_date: Moment().add(1, 'days').format('YYYY-MM-DD'),
        start_date_original: Moment().add(1, 'days').format('YYYY-MM-DD'),

        end_date: '',
        end_date_original: '',

        last_amount: null,
        last_amount_original: null,

        last_date: null,
        last_date_original: null,

        ongoing: false,
        ongoing_original: false
      },

      recurringTypes: [
        {value: 'none', text: 'None'},
        {value: 'weekly', text: 'Every week'},
        {value: 'biweekly', text: 'Every 2 weeks'},
        {value: 'monthly', text: 'Every month'},
        {value: 'annually', text: 'Every year'}
      ],

      downpaymentRules: [
        (v) => !isNaN(v) || 'Downpayment needs to be numeric',
        (v) => (v <= 500000) || 'Downpayment must be $500,000 or less',
        (v) => (v <= this.fields.remaining_balance) || 'Downpayment must less than or equal to the total amount'
      ],
      feeRules: [
        (v) => !isNaN(v) || 'Fee needs to be numeric'
      ],
      recurringFrequencyRules: [
        (v) => (!!v && v !== 'none') || 'Recurring frequency required'
      ],
      recurringStartRules: [
        // required if recurring
        // today or later
        (v) => (!!v && v !== '') || 'Recurring start date required'
      ],
      recurringEndRules: [
        // required if recurring
        // day after start date or later
        (v) => (!!v && v !== '' && !this.fields.ongoing) || 'Recurring end date required'
      ]
    }
  },

  props: {
    terminal: Object,
    custom: Object,
    transaction: Object,
    finalTransaction: Object,
    scheduledTransactions: Array
  },

  beforeDestroy () {
    // this.fields.remaining_balance = null
    // this.fields.frequency = 'none'
    // this.fields.payments = 0
    // this.fields.amount = null
    // this.fields.start_date = Moment().add(1, 'days').format('YYYY-MM-DD')
    // this.fields.end_date = ''
    // this.fields.last_amount = null
    // this.fields.last_date = null
    // this.fields.ongoing = false
  },

  mounted () {
    this.load()

    if (process.env.NODE_ENV !== 'production') {
      this.recurringTypes = [
        {value: 'none', text: 'None'},
        {value: 'daily', text: 'Every day'},
        {value: 'weekly', text: 'Every week'},
        {value: 'biweekly', text: 'Every 2 weeks'},
        {value: 'monthly', text: 'Every month'},
        {value: 'annually', text: 'Every year'}
      ]
    }
  },

  watch: {
    transaction: function () {
      this.load()
    },
    scheduledTransactions: function () {
      this.load()
    }
  },

  computed: {
    formattedRecurringStartDate () {
      return this.fields.start_date ? Moment(this.fields.start_date).format('MMM-DD-YYYY') : ''
    },

    formattedRecurringEndDate () {
      return this.fields.end_date ? Moment(this.fields.end_date).format('MMM-DD-YYYY') : ''
    },

    minimumRecurringStartDate: function () {
      return Moment().format('YYYY-MM-DD')
    },

    recurringPriceAdjustmentFee: function () {
      if (isNaN(this.fields.amount) || this.fields.amount === 0) {
        return ''
      }

      return this.calculateFee(this.terminal, this.fields.amount)
    },

    recurringLastAmountPriceAdjustmentFee: function () {
      if (isNaN(this.fields.last_amount) || this.fields.last_amount === 0) {
        return ''
      }

      return this.calculateFee(this.terminal, this.fields.last_amount)
    },

    submitDisabled: function () {
      return Number(this.fields.remaining_balance) !== Number(this.fields.remaining_balance_original) ||
        this.fields.frequency !== this.fields.frequency_original ||
        this.fields.start_date !== this.fields.start_date_original ||
        this.fields.end_date !== this.fields.end_date_original ||
        Number(this.fields.payments) !== Number(this.fields.payments_original) ||
        Number(this.fields.amount) !== Number(this.fields.amount_original) ||
        Number(this.fields.last_amount) !== Number(this.fields.last_amount_original)
    }
  },

  methods: {
    async load () {
      this.fields.waive_fee = this.transaction.is_fee_waived

      this.fields.frequency_original = this.fields.frequency = this.transaction.modify_recurring_type ? this.transaction.modify_recurring_type : this.transaction.recurring_type

      let potentialStartdate = this.transaction.modify_recurring_start ? this.transaction.modify_recurring_start : this.transaction.recurring_start

      if (this.transaction.recurring_next_date && Moment.utc(this.transaction.recurring_next_date).isAfter(Moment())) {
        this.fields.start_date_original = this.fields.start_date = Moment.utc(this.transaction.recurring_next_date).format('YYYY-MM-DD')
      } else if (Moment.utc(potentialStartdate).isAfter(Moment().add(1, 'days'))) {
        this.fields.start_date_original = this.fields.start_date = Moment.utc(potentialStartdate).format('YYYY-MM-DD')
      } else {
        this.fields.start_date_original = this.fields.start_date = Moment().add(1, 'days').format('YYYY-MM-DD')
      }

      if (this.transaction.modify_recurring_end) {
        this.fields.end_date_original = this.fields.end_date = Moment.utc(this.transaction.modify_recurring_end).format('YYYY-MM-DD') === '2099-12-31' ? '' : Moment.utc(this.transaction.modify_recurring_end).format('YYYY-MM-DD')
        this.fields.ongoing_original = this.fields.ongoing = !!(Moment.utc(this.transaction.modify_recurring_end).format('YYYY-MM-DD') === '2099-12-31')
      } else {
        this.fields.end_date_original = this.fields.end_date = Moment.utc(this.transaction.recurring_end).format('YYYY-MM-DD') === '2099-12-31' ? '' : Moment.utc(this.transaction.recurring_end).format('YYYY-MM-DD')
        this.fields.ongoing_original = this.fields.ongoing = !!(Moment.utc(this.transaction.recurring_end).format('YYYY-MM-DD') === '2099-12-31')
      }

      this.fields.close_date = this.transaction.future_post ? Moment.utc(this.transaction.future_post).format('YYYY-MM-DD') : null

      if (Object.keys(this.finalTransaction).length) {
        this.fields.payments++
        // this.fields.end_date_original = this.fields.end_date = Moment(this.fields.end_date, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
        this.fields.end_date_original = this.fields.end_date = Moment.utc(this.finalTransaction.future_post, 'YYYY-MM-DD').format('YYYY-MM-DD')

        this.fields.close_date = this.finalTransaction.future_post ? Moment.utc(this.finalTransaction.future_post).format('YYYY-MM-DD') : null

        this.fields.last_amount_original = this.fields.last_amount = ((this.finalTransaction.modify_total_amount ? this.finalTransaction.modify_total_amount : this.finalTransaction.total_amount) - (this.finalTransaction.modify_fee_amount ? this.finalTransaction.modify_fee_amount : this.finalTransaction.fee_amount)) / 100
      }

      this.fields.amount_original = this.fields.amount = ((this.transaction.modify_total_amount ? this.transaction.modify_total_amount : this.transaction.total_amount) - (this.transaction.modify_fee_amount ? this.transaction.modify_fee_amount : this.transaction.fee_amount)) / 100

      this.setPaymentCount()

      this.fields.payments_original = this.fields.payments

      this.fields.remaining_balance_original = this.fields.remaining_balance = (
        Number(((this.transaction.modify_total_amount ? this.transaction.modify_total_amount : this.transaction.total_amount) - (this.transaction.modify_fee_amount ? this.transaction.modify_fee_amount : this.transaction.fee_amount)) / 100 * this.scheduledTransactions.length) + Number(this.fields.last_amount)
      ).toFixed(2)
    },

    async save () {
      let responses = []
      let hasError = false

      try {
        Bus.$emit('openWaitModal')

        if (this.transaction.settled) {
          // modify settled transactions
          let options = {
            account_id: this.terminal.account_id,
            terminal_id: this.terminal.id,
            // transaction_id: this.transaction.custom_tracking_id,
            unique_id: this.transaction.tracking_id,
            token_id: this.transaction.token_id,
            billing_id: this.transaction.billing_id,
            transaction_group_id: this.transaction.transaction_group_custom_tracking_id,
            is_recurring: this.transaction.is_recurring,
            is_installment: this.transaction.is_installment
          }

          // @TODO will we set a new plan amount and count?
          // if (Number(this.fields.remaining_balance) !== Number(this.fields.remaining_balance_original)) {
          //   options.transaction_group_total_amount = this.fields.remaining_balance
          // }
          // if (Number(this.fields.payments) !== Number(this.fields.payments_original)) {
          //   options.transaction_group_total_count = this.fields.payments
          // }

          options.recurring_type = this.fields.frequency
          options.recurring_offset = new Date().getTimezoneOffset() / 60
          options.recurring_start = this.fields.start_date
          options.recurring_end = this.fields.end_date

          // if there is a last payment, rollback this payment's end date by one
          if (this.fields.last_amount && Number(this.fields.last_amount) > 0) {
            let previousEndDate = this.calculatePreviousRecurringDate(this.fields.frequency, this.fields.end_date)
            if (Moment(previousEndDate).isAfter(this.fields.start_date)) {
              options.recurring_end = previousEndDate
            } else {
              // options.recurring_end = Moment(this.fields.start_date, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
              options.recurring_end = this.fields.start_date
            }
          }

          // @TODO handle recurring ongoing
          // if (this.fields.ongoing) {
          //   options.recurring_end = '2099-12-31'
          // }

          options.total_amount = this.fields.amount
          if (this.transaction.is_cashdiscount && this.transaction.request_type !== 'ach' && !this.transaction.is_fee_waived) {
            options.fee_amount = this.recurringPriceAdjustmentFee
          } else if (this.transaction.is_cashdiscount && this.transaction.request_type !== 'ach' && this.transaction.is_fee_waived) {
            options.waive_fee = this.transaction.is_fee_waived
            options.fee_waived = this.recurringPriceAdjustmentFee
          }

          // options.recurring_notify = this.fields.recurring_notify
          // options.billing_postalcode = this.fields.billing_postalcode
          // options.billing_phone = this.fields.billing_phone
          // options.billing_email = this.fields.billing_email

          let result = await this.api({
            method: 'post',
            url: `/terminal/modify`,
            data: options
          })

          if (result.data) {
            if (result.data.response.ResponseText === 'MODIFY ACCEPTED') {
              responses.push({
                id: this.transaction.id,
                custom_tracking_id: this.transaction.custom_tracking_id,
                status: 'success'
              })
            } else {
              hasError = true
              responses.push({
                id: this.transaction.id,
                custom_tracking_id: this.transaction.custom_tracking_id,
                status: 'error',
                message: result.data.response.ResponseText,
                error: result.data.response.ErrMsg || ''
              })
            }
          } else {
            hasError = true
            responses.push({
              id: this.transaction.id,
              custom_tracking_id: this.transaction.custom_tracking_id,
              status: 'error',
              message: 'unknown',
              error: 'unknown'
            })
          }
        } else {
          // unsettled transaction, create new first, then void old
          // attempt to make new transaction
          let options = {
            account_id: this.terminal.account_id,
            terminal_id: this.terminal.id,
            token: this.transaction.token,
            billing_id: this.transaction.billing_id,
            transaction_group_id: this.transaction.transaction_group_custom_tracking_id,
            request_type: 'sale',
            is_recurring: true,
            is_installment: 1,
            recurring: this.fields.frequency,
            recurring_offset: new Date().getTimezoneOffset() / 60,
            recurring_start_date: this.fields.start_date,
            recurring_end_date: this.fields.end_date,
            amount: this.fields.amount,
            order_number: this.transaction.order_number,
            customer_po: this.transaction.customer_po,
            custom_field_1: this.transaction.custom_field_1,
            custom_field_2: this.transaction.custom_field_2,
            custom_field_3: this.transaction.custom_field_3,
            // custom: this.transaction.custom,
            custom: JSON.stringify(this.transaction.custom),
            notes: this.transaction.notes,
            transaction_group_total_amount: this.fields.remaining_balance,
            transaction_group_total_count: this.fields.payments
          }

          // if there is a last payment, rollback this payment's end date by one
          if (this.fields.last_amount && Number(this.fields.last_amount) > 0) {
            let previousEndDate = this.calculatePreviousRecurringDate(this.fields.frequency, this.fields.end_date)
            if (Moment(previousEndDate).isAfter(this.fields.start_date)) {
              options.recurring_end_date = previousEndDate
            } else {
              // options.recurring_end_date = Moment(this.fields.start_date, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
              options.recurring_end_date = this.fields.start_date
            }
          }

          options.card_name = this.transaction.card_name
          options.billing_address = this.transaction.billing_address
          options.billing_city = this.transaction.billing_city
          options.billing_state = this.transaction.billing_state
          options.billing_postalcode = this.transaction.billing_postal_code
          options.billing_country = this.transaction.billing_country

          if (this.transaction.request_type === 'ach') {
            options.request_type = 'ach'
            options.ach_is_authorized = this.transaction.ach_is_authorized
            options.ach_authorization = 'onfile'
            options.ach_type = this.transaction.ach_account_type
          }

          if (this.transaction.is_cashdiscount && this.transaction.request_type !== 'ach' && !this.transaction.is_fee_waived) {
            options.fee = this.recurringPriceAdjustmentFee
          } else if (this.transaction.is_cashdiscount && this.transaction.request_type !== 'ach' && this.transaction.is_fee_waived) {
            options.waive_fee = this.transaction.is_fee_waived
            options.fee_waived = this.recurringPriceAdjustmentFee
          }

          let result = await this.api({
            method: 'post',
            url: `/terminal/payment`,
            data: options
          })

          if (result.data.response.ResponseText === 'APPROVED' || result.data.response.ResponseText === 'PENDING' || result.data.response.ResponseText === 'CHECK ACCEPTED') {
            responses.push({
              transaction: result.data.response.Transaction,
              id: result.data.response.Transaction.id,
              custom_tracking_id: result.data.response.Transaction.custom_tracking_id,
              status: 'success'
            })
          } else {
            hasError = true
            responses.push({
              id: this.transaction.id,
              custom_tracking_id: this.transaction.custom_tracking_id,
              status: 'error',
              message: result.data.response.ResponseText,
              error: result.data.response.ErrMsg || ''
            })
          }

          if (!hasError) {
            // void original unsettled
            let voidOptions = {
              terminal_id: this.transaction.terminal_id,
              transaction_id: this.transaction.id
            }

            let voidResult = await this.api({
              method: 'post',
              url: `/terminal/void`,
              data: voidOptions
            })

            if (voidResult.data) {
              if (voidResult.data.response.ActionCode === '000') {
                responses.push({
                  id: this.transaction.id,
                  custom_tracking_id: this.transaction.custom_tracking_id,
                  status: 'success'
                })
              } else {
                hasError = true
                responses.push({
                  id: this.transaction.id,
                  custom_tracking_id: this.transaction.custom_tracking_id,
                  status: 'error',
                  message: result.data.response.ResponseText,
                  error: voidResult.data.response.ErrMsg || ''
                })
              }
            } else {
              hasError = true
              responses.push({
                id: this.transaction.id,
                custom_tracking_id: this.transaction.custom_tracking_id,
                status: 'error',
                message: 'unknown',
                error: 'unknown'
              })
            }
          }
        }

        // create new last payment if needed
        if (!hasError && this.fields.last_amount && Number(this.fields.last_amount) > 0 && (Number(this.fields.last_amount) !== Number(this.fields.last_amount_original) || this.fields.end_date !== this.fields.end_date_original)) {
          let lastOptions = {
            account_id: this.terminal.account_id,
            terminal_id: this.terminal.id,
            token: this.transaction.token,
            billing_id: this.transaction.billing_id,
            transaction_group_id: this.transaction.transaction_group_custom_tracking_id,
            request_type: 'sale',
            is_installment: 1,
            close_date: this.fields.end_date,
            amount: this.fields.last_amount,
            order_number: this.transaction.order_number,
            customer_po: this.transaction.customer_po,
            custom_field_1: this.transaction.custom_field_1,
            custom_field_2: this.transaction.custom_field_2,
            custom_field_3: this.transaction.custom_field_3,
            // custom: this.transaction.custom
            custom: JSON.stringify(this.transaction.custom)
          }

          lastOptions.card_name = this.transaction.card_name
          lastOptions.billing_address = this.transaction.billing_address
          lastOptions.billing_city = this.transaction.billing_city
          lastOptions.billing_state = this.transaction.billing_state
          lastOptions.billing_postalcode = this.transaction.billing_postal_code
          lastOptions.billing_country = this.transaction.billing_country

          if (this.transaction.request_type === 'ach') {
            lastOptions.request_type = 'ach'
            lastOptions.ach_is_authorized = this.transaction.ach_is_authorized
            lastOptions.ach_authorization = 'onfile'
            lastOptions.ach_type = this.transaction.ach_account_type
          }

          if (this.transaction.is_cashdiscount && this.transaction.request_type !== 'ach' && !this.transaction.is_fee_waived) {
            lastOptions.fee = this.recurringLastAmountPriceAdjustmentFee
          } else if (this.transaction.is_cashdiscount && this.transaction.request_type !== 'ach' && this.transaction.is_fee_waived) {
            lastOptions.waive_fee = this.transaction.is_fee_waived
            lastOptions.fee_waived = this.recurringLastAmountPriceAdjustmentFee
          }

          let lastResult = await this.api({
            method: 'post',
            url: `/terminal/payment`,
            data: lastOptions
          })

          if (lastResult.data.response.ResponseText === 'APPROVED' || lastResult.data.response.ResponseText === 'PENDING' || lastResult.data.response.ResponseText === 'CHECK ACCEPTED') {
            responses.push({
              transaction: lastResult.data.response.Transaction,
              id: lastResult.data.response.Transaction.id,
              custom_tracking_id: lastResult.data.response.Transaction.custom_tracking_id,
              status: 'success'
            })
          } else {
            hasError = true
            responses.push({
              id: this.transaction.id,
              custom_tracking_id: this.transaction.custom_tracking_id,
              status: 'error',
              message: lastResult.data.response.ResponseText,
              error: lastResult.data.response.ErrMsg || ''
            })
          }
        }

        // void previous last payment if needed
        if (!hasError && this.fields.last_amount && Number(this.fields.last_amount) > 0 && (Number(this.fields.last_amount) !== Number(this.fields.last_amount_original) || this.fields.end_date !== this.fields.end_date_original)) {
          // void original unsettled
          let lastVoidOptions = {
            terminal_id: this.finalTransaction.terminal_id,
            transaction_id: this.finalTransaction.id
          }

          let lastVoidResult = await this.api({
            method: 'post',
            url: `/terminal/void`,
            data: lastVoidOptions
          })

          if (lastVoidResult.data) {
            if (lastVoidResult.data.response.ActionCode === '000') {
              responses.push({
                id: this.finalTransaction.id,
                custom_tracking_id: this.finalTransaction.custom_tracking_id,
                status: 'success'
              })
            } else {
              hasError = true
              responses.push({
                id: this.finalTransaction.id,
                custom_tracking_id: this.finalTransaction.custom_tracking_id,
                status: 'error',
                message: lastVoidResult.data.response.ResponseText,
                error: lastVoidResult.data.response.ErrMsg || ''
              })
            }
          } else {
            hasError = true
            responses.push({
              id: this.finalTransaction.id,
              custom_tracking_id: this.finalTransaction.custom_tracking_id,
              status: 'error',
              message: 'unknown',
              error: 'unknown'
            })
          }
        }
      } catch (err) {
        Bus.$emit('openModal', {status: 'error', message: err})
      } finally {
        Bus.$emit('closeWaitModal')
      }

      if (!responses.length) {
        Bus.$emit('openModal', {status: 'info', message: 'Nothing to process'})
      } else if (hasError) {
        // Bus.$emit('openModal', {status: 'error', message: responses})
        console.log('ERROR')
        console.log(responses)
        Bus.$emit('openModal', {status: 'error', message: 'There has been an issue modifying the payment information. Please contact support'})
      } else {
        Bus.$emit('openModal', {status: 'success', message: 'Installment plan has been modified'})
        Bus.$emit('reloadPlan')
        this.closeModal()
      }
    },

    closeModal () {
      // this.fields.remaining_balance = null
      // this.fields.frequency = 'none'
      // this.fields.payments = 0
      // this.fields.amount = null
      // this.fields.start_date = Moment().add(1, 'days').format('YYYY-MM-DD')
      // this.fields.end_date = ''
      // this.fields.last_amount = null
      // this.fields.last_date = null
      // this.fields.ongoing = false

      Bus.$emit('closeModifyModal')
    },

    handleChange (field) {
      if (field === 'balance' || field === 'frequency') {
        // keep balance / frequncy
        // calculate payments
        // keep amount
        // keep start_date
        // calculate end_date
        // calculate last_payment

        // calculate payments
        let paymentCount = this.calculatePaymentCountWithRecurringAmount()
        this.$set(this.fields, 'payments', Math.ceil(paymentCount))

        // calculate end_date
        this.$set(this.fields, 'end_date', this.calculateEndDate(this.fields.frequency, this.fields.start_date, this.fields.payments))

        // add last payment if remainder
        if (Math.ceil(paymentCount) > paymentCount) {
          this.$set(this.fields, 'last_amount', Number(this.fields.remaining_balance - (Math.floor(paymentCount) * this.fields.amount)).toFixed(2))
        } else {
          this.$set(this.fields, 'last_amount', null)
        }
      } else if (field === 'payments') {
        // keep balance / frequncy
        // keep payments
        // calculate amount
        // keep start_date
        // calculate end_date
        // calculate last_payment

        // calculate installment payment amount
        let subtotal = this.fields.remaining_balance / this.fields.payments

        if (isNaN(subtotal) || subtotal === 0 || subtotal === Infinity) {
          return ''
        } else {
          this.$set(this.fields, 'amount', Number(subtotal).toFixed(2))
        }

        // calculate end date
        this.$set(this.fields, 'end_date', this.calculateEndDate(this.fields.frequency, this.fields.start_date, this.fields.payments))

        // add last payment if remainder
        let potentialAmount = this.fields.payments * this.fields.amount
        if (potentialAmount > this.fields.remaining_balance) {
          this.$set(this.fields, 'last_amount', Number(this.fields.remaining_balance - ((this.fields.payments - 1) * this.fields.amount)).toFixed(2))
        } else {
          this.$set(this.fields, 'last_amount', null)
        }
      } else if (field === 'amount') {
        // keep balance / frequncy
        // keep payments
        // calculate amount
        // keep start_date
        // calculate end_date
        // calculate last_payment

        // calculate # of payments
        if (this.fields.ongoing) {
          this.fields.end_date = ''
          this.fields.payments = 0
        } else {
          let paymentCount = this.calculatePaymentCountWithRecurringAmount()
          // this.fields.payments = Math.ceil(paymentCount)
          this.$set(this.fields, 'payments', Math.ceil(paymentCount))

          // add last payment if remainder
          if (Math.ceil(paymentCount) > paymentCount) {
            // this.fields.last_amount = this.recurringRemainingBalance - (Math.floor(paymentCount) * this.fields.amount)
            this.$set(this.fields, 'last_amount', Number(this.fields.remaining_balance - (Math.floor(paymentCount) * this.fields.amount)).toFixed(2))
          } else {
            this.$set(this.fields, 'last_amount', null)
          }
        }

        // calculate end date
        // this.fields.end_date = this.calculateEndDate()
        this.$set(this.fields, 'end_date', this.calculateEndDate(this.fields.frequency, this.fields.start_date, this.fields.payments))
      } else if (field === 'start_date') {
        // calculate End Date
        // calculate # or payments
        // calculate installment payments
        // if remainder, last payment

        // calculate end date
        this.$set(this.fields, 'end_date', this.calculateEndDate(this.fields.frequency, this.fields.start_date, this.fields.payments))
      } else if (field === 'end_date') {
        // calculate # of payments
        // calculate installment payments
        // no remainder, hide last payment
      }
    },

    calculatePaymentCountWithRecurringAmount () {
      if (this.fields.frequency === '' || this.fields.frequency === 'none') {
        return 0
      }
      if (this.fields.start_date === '') {
        return 0
      }
      if (this.fields.remaining_balance === '') {
        return 0
      }
      if (this.fields.amount === '') {
        return 0
      }

      return this.fields.remaining_balance / this.fields.amount
    },

    getPaymentCount () {
      let type = this.transaction.modify_recurring_type ? this.transaction.modify_recurring_type : this.transaction.recurring_type
      let start = this.transaction.modify_recurring_start ? this.transaction.modify_recurring_start : this.transaction.recurring_start
      let end = this.transaction.modify_recurring_end ? this.transaction.modify_recurring_end : this.transaction.recurring_end

      if (type === 'none' || !start || !end) {
        return 0
      }

      return Math.trunc(this.calculatePaymentCountWithEndDate(type, start, end))
    },

    setPaymentCount () {
      if (this.fields.ongoing) {
        // this.fields.end_date = ''
        this.$set(this.fields, 'end_date', '')
        // this.fields.payments = 0
        this.$set(this.fields, 'payments', 0)
      } else if (this.fields.frequency === 'none' || !this.fields.start_date || !this.fields.end_date) {
        this.$set(this.fields, 'payments', 0)
      } else {
        // this.fields.payments = Math.trunc(this.calculatePaymentCountWithEndDate())
        this.$set(this.fields, 'payments', Math.trunc(this.calculatePaymentCountWithEndDate(this.fields.frequency, this.fields.start_date, this.fields.end_date)))
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/plans/ModifyInstallments.vue